export const environment = {
  clientId: 'SSO_CLIENT',
  production: true,
  title: 'TRƯỜNG ĐẠI HỌC THƯƠNG MẠI',
  logo: '/assets/icon/logo-tmu.jpg',
  siteKeyCaptcha: '6LeXNEksAAAAABahuIbkiowH0z2MlYN8zcD8OB3Y',
  bgLogin: '/assets/img/bg-login-reduce.jpg',
  favicon: '/assets/icon/favicon-tmu.ico',
  copyright: 'Trường Đại học Thương mại • Cổng đăng nhập SSO',
  frontend: 'https://sso.tmu.edu.vn',
  backend: {
    sso: 'https://sso.tmu.edu.vn/sso-service'
  }
};
